import { AxiosError } from 'axios';
import AlertModal from 'components/common/AlertModal';
import ConfirmModal from 'components/common/ConfirmModal';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import { useEffect, useRef, useState } from 'react';
import { Col, Form, Row, Table } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { displayError, handleServiceError } from 'utils/axiosError';
import { ApplicableCourse, ApplicableCoursePayload } from '../models/courseOrderLimit';
import AddApplicableCourseModal from '../page/AddApplicableCourseModal';
import { courseOrderLimitService } from '../services';
// import DetailModal from './Detail';
// define props
interface DataTableProps {
  dataTable: ApplicableCourse[];
  setDataTable: (dataTable: ApplicableCourse[] | []) => void;
  onReflect: (
    selectedApplicableCourse: Array<{ id: number; name: string; menu_book_name: string; menu_book_id: number }>
  ) => void;
  exceptApplicableCourseIds?: number[];
  limitType: number;
}

function TableList({ dataTable, setDataTable, onReflect, exceptApplicableCourseIds, limitType }: DataTableProps) {
  const { t } = useTranslation();
  const { showGlobalModal } = useGlobalModal();
  // state
  const initialState = dataTable.reduce((o, key) => ({ ...o, [key.id]: false }), {});
  const [checked, setChecked] = useState<any>(initialState);
  const [showAddModal, setShowAddModal] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [applicableCourse, setApplicableCourse] = useState<ApplicableCourse[]>([]);
  // ref
  const refBtnOnReflect = useRef<HTMLButtonElement>(null);

  // toggle checkbox
  function toggleCheck(value: number) {
    let newState = { ...checked };
    newState[value] = !newState[value];
    setChecked(newState);
  }

  // handle delete applicable course
  async function deleteApplicableCourse(data: ApplicableCourse[], limit_type: number) {
    try {
      const payload: ApplicableCoursePayload[] = data
        .filter((item) => item.delete_flg === true)
        .map((item) => ({
          course_id: item.id,
          limit_type,
        }));
      await courseOrderLimitService.deleteCourseOrderLimit(payload).then((res) => {
        showGlobalModal(() => (
          <AlertModal title={t('applicableCoursesModal.info')} message={t('applicableCoursesModal.delete_success')} />
        ));
      });
    } catch (error) {
      if (!handleServiceError(showGlobalModal, error as AxiosError)) {
        displayError(showGlobalModal, error as AxiosError);
      }
    }
  }
  const handleDelete = () => {
    const updatedData = dataTable.map((course) => {
      return checked[course.id] ? { ...course, delete_flg: true, is_select: false } : course;
    });
    const deleteData = updatedData.filter((course) => course.delete_flg === true);
    showGlobalModal(() => (
      <ConfirmModal
        title={t('applicableCoursesModal.info')}
        message={t('applicableCoursesModal.delete_warning')}
        onConfirm={() => {
          deleteApplicableCourse(deleteData, limitType);
          setDataTable(updatedData.filter((course) => course.delete_flg === false));
          setChecked({});
        }}
      />
    ));
  };
  // handle add applicable course
  const handleAddApplicableCourses = () => {
    setShowAddModal(true);
  };

  // useEffects check change checked
  useEffect(() => {
    // handle disabled btn view detail
    function handleDisableBtnViewDetail() {
      let count = Object.keys(checked).filter((key) => checked[key] === true).length;
      if (count > 0) {
        return false;
      }
      return true;
    }

    if (handleDisableBtnViewDetail()) {
      if (refBtnOnReflect.current) refBtnOnReflect.current.disabled = true;
    } else {
      if (refBtnOnReflect.current) refBtnOnReflect.current.disabled = false;
    }
  }, [checked]);

  return (
    <>
      {applicableCourse}
      <Row className=" mb-2">
        <Col className="d-flex justify-content-end">
          <span className="ps-2 pe-2"></span>
          <button
            type="button"
            className="btn btn--dark-green"
            ref={refBtnOnReflect}
            onClick={handleAddApplicableCourses}
          >
            {t('applicableCoursesModal.add_button')}
          </button>
          <button type="button" className="btn btn--red ms-3" ref={refBtnOnReflect} onClick={handleDelete}>
            {t('applicableCoursesModal.delete_button')}
          </button>
        </Col>
      </Row>
      <div className="sticky-table" style={{ height: 360, maxHeight: 360 }}>
        <Table bordered style={{ borderRight: '1px solid #dee2e6' }}>
          <thead className="text-center" style={{ backgroundColor: '#36489a', color: '#fff' }}>
            <tr>
              <th rowSpan={2} className="align-top" style={{ width: '10%' }}>
                {t('applicableCoursesModal.delete_title')}
              </th>
              <th rowSpan={1} className="align-top" style={{ width: '30%' }}>
                {t('applicableCoursesModal.menu_book_title')}
              </th>
              <th rowSpan={1} className="align-top" style={{ width: '60%' }}>
                {t('applicableCoursesModal.course_title')}
              </th>
            </tr>
          </thead>
          <tbody>
            {dataTable &&
              dataTable.map((value: ApplicableCourse) => (
                <tr key={value.id}>
                  {exceptApplicableCourseIds?.includes(value.id) === false &&
                    (!value.delete_flg || value.is_select) && (
                      <>
                        {/* Checkbox column */}
                        <td style={{ width: '10%' }} className="text-center">
                          <Form.Check
                            type="checkbox"
                            value={value.id}
                            checked={checked[value.id] || false}
                            onChange={() => toggleCheck(value.id)}
                            disabled={exceptApplicableCourseIds?.includes(value.id)}
                          />
                        </td>
                        {/* Menu Book Name column */}
                        <td style={{ width: '30%' }} className="text-center">
                          <div className="" data-id={value.menu_book_id}>
                            {value.menu_book_name}
                          </div>
                        </td>
                        {/* Course Name column */}
                        <td style={{ width: '60%' }} className="text-center">
                          <div className="" data-id={value.id}>
                            {value.name}
                          </div>
                        </td>
                      </>
                    )}
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
      {showAddModal &&
        createPortal(
          <AddApplicableCourseModal
            isShowModal={showAddModal}
            onClose={() => setShowAddModal(false)}
            setDataTable={setDataTable}
            exceptApplicableCourseIds={exceptApplicableCourseIds}
            dataTable={dataTable}
            onReflect={onReflect}
          />,
          document.body
        )}
    </>
  );
}

export default TableList;
